import React from "react";
import { Box, Typography } from "@mui/material";
import FieldValidationMessage from "./FieldValidationMessage";

export const ACCORDION_SUMMARY_HEIGHT_PX = 43;
export const ACCORDION_SUMMARY_WITH_ERROR_HEIGHT_PX = 58;

export function AccordionSummaryWithValidation({ title, error, titleStyle }) {
  const hasError = Boolean(error);

  if (!hasError) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          height: "100%",
        }}
      >
        <Typography style={titleStyle}>{title}</Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        width: "100%",
        height: "100%",
        pt: 0.5,
        gap: 0.25,
      }}
    >
      <Typography style={titleStyle}>{title}</Typography>
      <FieldValidationMessage message={error} compact />
    </Box>
  );
}

export function getAccordionSummarySx(hasError) {
  const height = hasError
    ? ACCORDION_SUMMARY_WITH_ERROR_HEIGHT_PX
    : ACCORDION_SUMMARY_HEIGHT_PX;

  return {
    minHeight: `${height}px !important`,
    height: `${height}px !important`,
    "&.Mui-expanded": {
      minHeight: `${height}px !important`,
      height: `${height}px !important`,
    },
    "& .MuiAccordionSummary-content": {
      alignItems: "stretch",
      margin: 0,
      width: "100%",
    },
  };
}
